SupportBasePresentation = require('./base')
SupportPresenterUtilPresentation = require('./presenter_util')
SupportGetawaysBookingStatusAndNotesPresentation = require('./getaways_booking_messages')

class SupportGetawaysBookingPresenterPresentation extends SupportBasePresentation
  getLookupObject: () ->
    SupportGetawaysBookingStatusAndNotesPresentation

  getLookupKeySequence: () ->
    keys = []

    if @order?
        keys.push(SupportPresenterUtilPresentation::getEditableKey(@order.isEditable))
        keys.push(SupportPresenterUtilPresentation::getGetawaysBookingStatus(@order))
    SupportPresenterUtilPresentation::concatenateLookupKeys(keys)

module.exports = SupportGetawaysBookingPresenterPresentation
